// extracted by mini-css-extract-plugin
export default {"mainDiv":"UpdateWhatsapp_mainDiv__kx+Yd","container":"UpdateWhatsapp_container__1Lev0","button":"UpdateWhatsapp_button__WyVaf"};